import type { CurveType } from "recharts/types/shape/Curve";

export const CHART_RADIUS = 3;
export const CHART_PADDING = 5;

export const AREA_CURVE_TYPES: CurveType[] = [
	"basis",
	"basisClosed",
	"basisOpen",
	"bump",
	"bumpX",
	"bumpY",
	"linear",
	"linearClosed",
	"monotone",
	"monotoneX",
	"monotoneY",
	"natural",
	"step",
	"stepAfter",
	"stepBefore",
];

export type CurveTypeString =
	| "basis"
	| "basisClosed"
	| "basisOpen"
	| "bump"
	| "bumpX"
	| "bumpY"
	| "linear"
	| "linearClosed"
	| "monotone"
	| "monotoneX"
	| "monotoneY"
	| "natural"
	| "step"
	| "stepAfter"
	| "stepBefore";
